import { init } from '@resuelve/malinchex'

const malinchexInit = () => {
  const server = process.env.REACT_APP_MALINCHEX_SERVER
  return init(server, navigator.language)
}

export default malinchexInit
